var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon4({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 102,
    viewBox: "0 0 92 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.29688 35.7653C1.29688 31.1403 5.04682 27.3903 9.67188 27.3903C14.2969 27.3903 18.0469 31.1403 18.0469 35.7653C18.0469 40.3926 14.2971 44.1403 9.67188 44.1403C5.04665 44.1403 1.29688 40.3926 1.29688 35.7653Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1094 7.64034C34.1094 5.60479 35.7596 3.95284 37.7969 3.95284C39.8341 3.95284 41.4844 5.60479 41.4844 7.64034C41.4844 9.67789 39.8344 11.3278 37.7969 11.3278C35.7593 11.3278 34.1094 9.67769 34.1094 7.64034Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6406 80.2966C78.6406 76.9672 81.3408 74.2653 84.6719 74.2653C88.003 74.2653 90.7031 76.9672 90.7031 80.2966C90.7031 83.6277 88.0032 86.3278 84.6719 86.3278C81.3406 86.3278 78.6406 83.6277 78.6406 80.2966Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2905 63.066L17.5833 63.7731L18.2905 64.4803L34.8631 81.0527L35.5702 81.7598L36.2773 81.0527L76.0531 41.2793L76.7602 40.5722L76.0531 39.865L59.4804 23.2924L58.7734 22.5853L58.0663 23.2923L18.2905 63.066Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3365 2.52712L69.336 2.52869C69.1005 3.23402 69.4819 3.99482 70.1837 4.22772L70.1855 4.22832C70.8891 4.46331 71.6496 4.08371 71.8851 3.3788C72.1196 2.67641 71.7394 1.91506 71.0355 1.67923L69.3365 2.52712ZM69.3365 2.52712C69.5696 1.82512 70.3305 1.44386 71.0354 1.67917L69.3365 2.52712Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.36724 14.2474L1.36776 14.2459C1.60072 13.5443 2.36161 13.1621 3.06734 13.3958C3.77082 13.6319 4.15082 14.393 3.91631 15.0952C3.68101 15.7997 2.9204 16.1803 2.21588 15.9468C1.51151 15.711 1.13229 14.9511 1.36724 14.2474Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3823 26.8156L34.3829 26.814C34.6178 26.1106 34.2386 25.3504 33.5342 25.1147C32.8297 24.8812 32.0691 25.2617 31.8338 25.9662L34.3823 26.8156ZM34.3823 26.8156C34.1494 27.5172 33.3885 27.8993 32.6827 27.6656M34.3823 26.8156L32.6827 27.6656M32.6827 27.6656C31.9793 27.4296 31.5993 26.6687 31.8338 25.9662L32.6827 27.6656Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.399 63.4649L83.3985 63.4665C83.1636 64.1698 83.5427 64.9298 84.2471 65.1655C84.9517 65.399 85.7123 65.0185 85.9476 64.3142L83.399 63.4649ZM83.399 63.4649C83.632 62.7633 84.3929 62.3811 85.0986 62.6148M83.399 63.4649L85.0986 62.6148M85.0986 62.6148C85.802 62.8508 86.1821 63.6119 85.9476 64.3141L85.0986 62.6148Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6641 99.4704L22.6636 99.472C22.4307 100.173 21.6698 100.556 20.964 100.322C20.2604 100.086 19.8806 99.3248 20.115 98.6227C20.3503 97.9182 21.1109 97.5377 21.8154 97.7711C22.5198 98.0069 22.899 98.7671 22.6641 99.4704Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6178 98.6211L57.6172 98.6227C57.3823 99.326 57.7614 100.086 58.4659 100.322C59.1704 100.555 59.931 100.175 60.1663 99.4704L57.6178 98.6211ZM57.6178 98.6211C57.8507 97.9195 58.6116 97.5374 59.3173 97.771M57.6178 98.6211L59.3173 97.771M59.3173 97.771C60.0208 98.0071 60.4008 98.7682 60.1663 99.4704L59.3173 97.771Z",
    fill: "#E7E0F0",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7309 59.817C11.7722 58.9498 12.823 58.5435 13.4369 59.1574L40.1883 85.9089C40.8022 86.5227 40.396 87.5736 39.5288 87.6148L11.44 88.9522C10.8508 88.9803 10.3655 88.495 10.3935 87.9058L11.7309 59.817Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1426 18.4234C53.5422 17.823 53.9291 16.7726 54.8154 16.7304L82.9039 15.393C83.493 15.365 83.9784 15.8503 83.9503 16.4395L82.6129 44.5283C82.5708 45.4122 81.5206 45.8015 80.9185 45.1994L54.1426 18.4234Z",
    fill: "#BA83B8",
    stroke: "#4D2481",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon-4.919db5b336c738384905caeec8aff1c7.svg";
export { ForwardRef as ReactComponent };